import {
  OrganizationId,
  type PartnerProgramDomainSelectModel,
  PartnerProgramId,
  PartnerProgramKinds,
} from '@mntn-dev/domain-types'
import { getRandomItem } from '@mntn-dev/utilities'

import { MockModel } from './mock-model.ts'

export const MockPartnerProgram = MockModel<PartnerProgramDomainSelectModel>(
  ({
    partnerProgramId = PartnerProgramId(),
    organizationId = OrganizationId(),
    partnerProgramKind = getRandomItem(PartnerProgramKinds),
    programMembershipId = undefined,
  }) => {
    return {
      partnerProgramId,
      organizationId,
      partnerProgramKind,
      programMembershipId,
    } satisfies PartnerProgramDomainSelectModel
  }
)
